// The log viewer addresses a specific transcript node via a tab + search param:
// the transcript tab with `?event=<uuid>`, or the messages tab with
// `?message=<id>`. It reads these on load and scrolls to / highlights the node.
export type SampleViewAnchor =
  | { tab: 'transcript'; param: 'event'; value: string }
  | { tab: 'messages'; param: 'message'; value: string };

export const getEvalSetViewUrl = (evalSetId: string) =>
  `/eval-set/${encodeURIComponent(evalSetId)}`;

export const getLogViewUrl = ({
  evalSetId,
  filename,
}: {
  evalSetId: string;
  filename: string;
}) => `${getEvalSetViewUrl(evalSetId)}#/logs/${encodeURIComponent(filename)}`;

export const getSampleViewUrl = ({
  evalSetId,
  filename,
  sampleId,
  epoch,
  anchor,
}: {
  evalSetId: string;
  filename: string;
  sampleId: string;
  epoch: number;
  anchor?: SampleViewAnchor;
}) => {
  const base = `${getLogViewUrl({ evalSetId, filename })}/samples/sample/${encodeURIComponent(sampleId)}/${epoch}/`;
  if (!anchor) return base;
  return `${base}${anchor.tab}?${anchor.param}=${encodeURIComponent(anchor.value)}`;
};
